import * as React from "react";

const SpecialOrder: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
            <g fill="none" fillRule="evenodd">
                <g fill="#004DA6" fillRule="nonzero">
                    <path d="M6.985 0c-.123.006-.23.088-.268.205L5.22 4.691H.433v.001c-.129 0-.243.083-.282.205-.04.122.003.256.106.333l3.89 2.844-1.496 4.643c-.04.122.004.257.109.332.105.077.246.076.35 0L7 10.204l3.89 2.845c.104.076.245.077.35 0 .105-.075.149-.21.109-.333L9.854 8.073l3.89-2.844c.102-.076.145-.21.105-.332-.04-.122-.153-.205-.282-.205H8.778L7.283.206C7.242.077 7.12-.007 6.985 0z" />
                </g>
            </g>
        </svg>
    );
};

export default React.memo(SpecialOrder);
